import gql from 'graphql-tag'

export const exportOpportunityResults = gql`
  mutation ExportOpportunityResults($id: String!) {
    exportOpportunityResults(id: $id) {
      success
    }
  }
`
